/* tslint:disable */
/* eslint-disable */
/**
 * Resell communication manager adapter API
 * Resell communication manager adapter API
 *
 * The version of the OpenAPI document: 0.5.0
 * Contact: mariogg@servicioexterno.inditex.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { Configuration } from './configuration';
import type { AxiosPromise, AxiosInstance, AxiosRequestConfig } from 'axios';
import globalAxios from 'axios';
// Some imports not used depending on template conditions
// @ts-ignore
import { DUMMY_BASE_URL, assertParamExists, setApiKeyToObject, setBasicAuthToObject, setBearerAuthToObject, setOAuthToObject, setSearchParams, serializeDataIfNeeded, toPathString, createRequestFunction } from './common';
import type { RequestArgs } from './base';
// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS, BaseAPI, RequiredError } from './base';

/**
 * 
 * @export
 * @interface ActionData
 */
export interface ActionData {
    /**
     * 
     * @type {string}
     * @memberof ActionData
     */
    'name'?: string;
}
/**
 * 
 * @export
 * @interface ArrayReturnData
 */
export interface ArrayReturnData {
    /**
     * 
     * @type {Array<CommunicationReturnData>}
     * @memberof ArrayReturnData
     */
    'sourceUser'?: Array<CommunicationReturnData>;
    /**
     * 
     * @type {Array<CommunicationReturnData>}
     * @memberof ArrayReturnData
     */
    'destinyUser'?: Array<CommunicationReturnData>;
}
/**
 * 
 * @export
 * @interface CommunicationEntryData
 */
export interface CommunicationEntryData {
    /**
     * 
     * @type {string}
     * @memberof CommunicationEntryData
     */
    'workflow'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunicationEntryData
     */
    'marketIso'?: string;
    /**
     * 
     * @type {MetadataData}
     * @memberof CommunicationEntryData
     */
    'metadata'?: MetadataData;
    /**
     * 
     * @type {object}
     * @memberof CommunicationEntryData
     */
    'extensionData'?: object;
}
/**
 * 
 * @export
 * @interface CommunicationListData
 */
export interface CommunicationListData {
    /**
     * 
     * @type {number}
     * @memberof CommunicationListData
     */
    'total'?: number;
    /**
     * 
     * @type {Array<CommunicationReturnData>}
     * @memberof CommunicationListData
     */
    'communications'?: Array<CommunicationReturnData>;
}
/**
 * 
 * @export
 * @interface CommunicationReturnData
 */
export interface CommunicationReturnData {
    /**
     * 
     * @type {string}
     * @memberof CommunicationReturnData
     */
    'id'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunicationReturnData
     */
    'workflow'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunicationReturnData
     */
    'template'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunicationReturnData
     */
    'status'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunicationReturnData
     */
    'marketIso'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunicationReturnData
     */
    'createdAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunicationReturnData
     */
    'updatedAt'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunicationReturnData
     */
    'destinyUserId'?: string;
    /**
     * 
     * @type {string}
     * @memberof CommunicationReturnData
     */
    'sourceUserId'?: string;
    /**
     * 
     * @type {boolean}
     * @memberof CommunicationReturnData
     */
    'viewed'?: boolean;
    /**
     * 
     * @type {MetadataData}
     * @memberof CommunicationReturnData
     */
    'metadata'?: MetadataData;
    /**
     * 
     * @type {Array<ActionData>}
     * @memberof CommunicationReturnData
     */
    'actions'?: Array<ActionData>;
    /**
     * 
     * @type {object}
     * @memberof CommunicationReturnData
     */
    'extensionData'?: object;
}
/**
 * 
 * @export
 * @interface Data
 */
export interface Data {
    /**
     * 
     * @type {string}
     * @memberof Data
     */
    'data'?: string;
}
/**
 * 
 * @export
 * @interface MetadataData
 */
export interface MetadataData {
    /**
     * 
     * @type {number}
     * @memberof MetadataData
     */
    'entityId'?: number;
    /**
     * 
     * @type {string}
     * @memberof MetadataData
     */
    'entityType'?: string;
    /**
     * 
     * @type {string}
     * @memberof MetadataData
     */
    'productStatus'?: string;
}
/**
 * 
 * @export
 * @interface ModelError
 */
export interface ModelError {
    /**
     * Status error
     * @type {string}
     * @memberof ModelError
     */
    'status'?: string;
    /**
     * Error identifier
     * @type {string}
     * @memberof ModelError
     */
    'error': string;
    /**
     * Error message
     * @type {string}
     * @memberof ModelError
     */
    'message'?: string;
    /**
     * Error detail
     * @type {string}
     * @memberof ModelError
     */
    'detail'?: string;
}
/**
 * 
 * @export
 * @interface TemplateTranslate
 */
export interface TemplateTranslate {
    /**
     * 
     * @type {object}
     * @memberof TemplateTranslate
     */
    'template'?: object;
}
/**
 * 
 * @export
 * @interface Token
 */
export interface Token {
    /**
     * 
     * @type {string}
     * @memberof Token
     */
    'token'?: string;
}

/**
 * CommunicationApi - axios parameter creator
 * @export
 */
export const CommunicationApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * get specific process communication
         * @summary get specific process communication
         * @param {string} id communication identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommunication: async (id: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCommunication', 'id', id)
            const localVarPath = `/api/preowned-resell/1/communication/id/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get specific process communication by workflow and product
         * @summary get specific process communication by workflow and product
         * @param {string} workflow communication workflow type
         * @param {string} product product identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommunicationByWorkflowAndProduct: async (workflow: string, product: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workflow' is not null or undefined
            assertParamExists('getCommunicationByWorkflowAndProduct', 'workflow', workflow)
            // verify required parameter 'product' is not null or undefined
            assertParamExists('getCommunicationByWorkflowAndProduct', 'product', product)
            const localVarPath = `/api/preowned-resell/1/communication/workflow/{workflow}/product/{product}`
                .replace(`{${"workflow"}}`, encodeURIComponent(String(workflow)))
                .replace(`{${"product"}}`, encodeURIComponent(String(product)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * process communication
         * @summary process communication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessCommunication: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/api/preowned-resell/1/communication`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get specific process communication by workflow and product
         * @summary get specific process communication by workflow and product
         * @param {string} workflow communication workflow type
         * @param {string} product product identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPubCommunicationByWorkflowAndProduct: async (workflow: string, product: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'workflow' is not null or undefined
            assertParamExists('getPubCommunicationByWorkflowAndProduct', 'workflow', workflow)
            // verify required parameter 'product' is not null or undefined
            assertParamExists('getPubCommunicationByWorkflowAndProduct', 'product', product)
            const localVarPath = `/api/preowned-resell/1/pub/communication/workflow/{workflow}/product/{product}`
                .replace(`{${"workflow"}}`, encodeURIComponent(String(workflow)))
                .replace(`{${"product"}}`, encodeURIComponent(String(product)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * process communication
         * @summary process communication
         * @param {number} storeId store identifier
         * @param {CommunicationEntryData} communicationEntryData update process communication object
         * @param {string} [lang] language code for communication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processCommunication: async (storeId: number, communicationEntryData: CommunicationEntryData, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('processCommunication', 'storeId', storeId)
            // verify required parameter 'communicationEntryData' is not null or undefined
            assertParamExists('processCommunication', 'communicationEntryData', communicationEntryData)
            const localVarPath = `/api/preowned-resell/1/communication`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(communicationEntryData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * process communication with user id
         * @summary process communication with user id
         * @param {number} storeId store identifier
         * @param {CommunicationEntryData} communicationEntryData update process communication object
         * @param {number} [userId] user identifier for external communication
         * @param {string} [lang] language code for communication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processCommunicationExternal: async (storeId: number, communicationEntryData: CommunicationEntryData, userId?: number, lang?: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'storeId' is not null or undefined
            assertParamExists('processCommunicationExternal', 'storeId', storeId)
            // verify required parameter 'communicationEntryData' is not null or undefined
            assertParamExists('processCommunicationExternal', 'communicationEntryData', communicationEntryData)
            const localVarPath = `/api/preowned-resell/1/communication-external`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'POST', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxApiKeyAuth required
            await setApiKeyToObject(localVarHeaderParameter, "accessToken", configuration)

            if (storeId !== undefined) {
                localVarQueryParameter['storeId'] = storeId;
            }

            if (userId !== undefined) {
                localVarQueryParameter['userId'] = userId;
            }

            if (lang !== undefined) {
                localVarQueryParameter['lang'] = lang;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(communicationEntryData, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * update process communication
         * @summary update process communication
         * @param {string} id communication identifier
         * @param {string} actionId action identifier for communication update
         * @param {object} body process communication object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCommunication: async (id: string, actionId: string, body: object, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('updateCommunication', 'id', id)
            // verify required parameter 'actionId' is not null or undefined
            assertParamExists('updateCommunication', 'actionId', actionId)
            // verify required parameter 'body' is not null or undefined
            assertParamExists('updateCommunication', 'body', body)
            const localVarPath = `/api/preowned-resell/1/communication/id/{id}`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'PATCH', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (actionId !== undefined) {
                localVarQueryParameter['actionId'] = actionId;
            }


    
            localVarHeaderParameter['Content-Type'] = 'application/json';

            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};
            localVarRequestOptions.data = serializeDataIfNeeded(body, localVarRequestOptions, configuration)

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * CommunicationApi - functional programming interface
 * @export
 */
export const CommunicationApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = CommunicationApiAxiosParamCreator(configuration)
    return {
        /**
         * get specific process communication
         * @summary get specific process communication
         * @param {string} id communication identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommunication(id: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommunicationReturnData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommunication(id, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get specific process communication by workflow and product
         * @summary get specific process communication by workflow and product
         * @param {string} workflow communication workflow type
         * @param {string} product product identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommunicationByWorkflowAndProduct(workflow: string, product: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Array<CommunicationReturnData>>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommunicationByWorkflowAndProduct(workflow, product, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * process communication
         * @summary process communication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getProcessCommunication(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<ArrayReturnData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getProcessCommunication(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get specific process communication by workflow and product
         * @summary get specific process communication by workflow and product
         * @param {string} workflow communication workflow type
         * @param {string} product product identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getPubCommunicationByWorkflowAndProduct(workflow: string, product: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommunicationListData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getPubCommunicationByWorkflowAndProduct(workflow, product, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * process communication
         * @summary process communication
         * @param {number} storeId store identifier
         * @param {CommunicationEntryData} communicationEntryData update process communication object
         * @param {string} [lang] language code for communication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processCommunication(storeId: number, communicationEntryData: CommunicationEntryData, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommunicationReturnData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.processCommunication(storeId, communicationEntryData, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * process communication with user id
         * @summary process communication with user id
         * @param {number} storeId store identifier
         * @param {CommunicationEntryData} communicationEntryData update process communication object
         * @param {number} [userId] user identifier for external communication
         * @param {string} [lang] language code for communication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async processCommunicationExternal(storeId: number, communicationEntryData: CommunicationEntryData, userId?: number, lang?: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommunicationReturnData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.processCommunicationExternal(storeId, communicationEntryData, userId, lang, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * update process communication
         * @summary update process communication
         * @param {string} id communication identifier
         * @param {string} actionId action identifier for communication update
         * @param {object} body process communication object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async updateCommunication(id: string, actionId: string, body: object, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<CommunicationReturnData>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.updateCommunication(id, actionId, body, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * CommunicationApi - factory interface
 * @export
 */
export const CommunicationApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = CommunicationApiFp(configuration)
    return {
        /**
         * get specific process communication
         * @summary get specific process communication
         * @param {string} id communication identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommunication(id: string, options?: any): AxiosPromise<CommunicationReturnData> {
            return localVarFp.getCommunication(id, options).then((request) => request(axios, basePath));
        },
        /**
         * get specific process communication by workflow and product
         * @summary get specific process communication by workflow and product
         * @param {string} workflow communication workflow type
         * @param {string} product product identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommunicationByWorkflowAndProduct(workflow: string, product: string, options?: any): AxiosPromise<Array<CommunicationReturnData>> {
            return localVarFp.getCommunicationByWorkflowAndProduct(workflow, product, options).then((request) => request(axios, basePath));
        },
        /**
         * process communication
         * @summary process communication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getProcessCommunication(options?: any): AxiosPromise<ArrayReturnData> {
            return localVarFp.getProcessCommunication(options).then((request) => request(axios, basePath));
        },
        /**
         * get specific process communication by workflow and product
         * @summary get specific process communication by workflow and product
         * @param {string} workflow communication workflow type
         * @param {string} product product identifier
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getPubCommunicationByWorkflowAndProduct(workflow: string, product: string, options?: any): AxiosPromise<CommunicationListData> {
            return localVarFp.getPubCommunicationByWorkflowAndProduct(workflow, product, options).then((request) => request(axios, basePath));
        },
        /**
         * process communication
         * @summary process communication
         * @param {number} storeId store identifier
         * @param {CommunicationEntryData} communicationEntryData update process communication object
         * @param {string} [lang] language code for communication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processCommunication(storeId: number, communicationEntryData: CommunicationEntryData, lang?: string, options?: any): AxiosPromise<CommunicationReturnData> {
            return localVarFp.processCommunication(storeId, communicationEntryData, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * process communication with user id
         * @summary process communication with user id
         * @param {number} storeId store identifier
         * @param {CommunicationEntryData} communicationEntryData update process communication object
         * @param {number} [userId] user identifier for external communication
         * @param {string} [lang] language code for communication
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        processCommunicationExternal(storeId: number, communicationEntryData: CommunicationEntryData, userId?: number, lang?: string, options?: any): AxiosPromise<CommunicationReturnData> {
            return localVarFp.processCommunicationExternal(storeId, communicationEntryData, userId, lang, options).then((request) => request(axios, basePath));
        },
        /**
         * update process communication
         * @summary update process communication
         * @param {string} id communication identifier
         * @param {string} actionId action identifier for communication update
         * @param {object} body process communication object
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        updateCommunication(id: string, actionId: string, body: object, options?: any): AxiosPromise<CommunicationReturnData> {
            return localVarFp.updateCommunication(id, actionId, body, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * CommunicationApi - interface
 * @export
 * @interface CommunicationApi
 */
export interface CommunicationApiInterface {
    /**
     * get specific process communication
     * @summary get specific process communication
     * @param {string} id communication identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunicationApiInterface
     */
    getCommunication(id: string, options?: AxiosRequestConfig): AxiosPromise<CommunicationReturnData>;

    /**
     * get specific process communication by workflow and product
     * @summary get specific process communication by workflow and product
     * @param {string} workflow communication workflow type
     * @param {string} product product identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunicationApiInterface
     */
    getCommunicationByWorkflowAndProduct(workflow: string, product: string, options?: AxiosRequestConfig): AxiosPromise<Array<CommunicationReturnData>>;

    /**
     * process communication
     * @summary process communication
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunicationApiInterface
     */
    getProcessCommunication(options?: AxiosRequestConfig): AxiosPromise<ArrayReturnData>;

    /**
     * get specific process communication by workflow and product
     * @summary get specific process communication by workflow and product
     * @param {string} workflow communication workflow type
     * @param {string} product product identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunicationApiInterface
     */
    getPubCommunicationByWorkflowAndProduct(workflow: string, product: string, options?: AxiosRequestConfig): AxiosPromise<CommunicationListData>;

    /**
     * process communication
     * @summary process communication
     * @param {number} storeId store identifier
     * @param {CommunicationEntryData} communicationEntryData update process communication object
     * @param {string} [lang] language code for communication
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunicationApiInterface
     */
    processCommunication(storeId: number, communicationEntryData: CommunicationEntryData, lang?: string, options?: AxiosRequestConfig): AxiosPromise<CommunicationReturnData>;

    /**
     * process communication with user id
     * @summary process communication with user id
     * @param {number} storeId store identifier
     * @param {CommunicationEntryData} communicationEntryData update process communication object
     * @param {number} [userId] user identifier for external communication
     * @param {string} [lang] language code for communication
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunicationApiInterface
     */
    processCommunicationExternal(storeId: number, communicationEntryData: CommunicationEntryData, userId?: number, lang?: string, options?: AxiosRequestConfig): AxiosPromise<CommunicationReturnData>;

    /**
     * update process communication
     * @summary update process communication
     * @param {string} id communication identifier
     * @param {string} actionId action identifier for communication update
     * @param {object} body process communication object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunicationApiInterface
     */
    updateCommunication(id: string, actionId: string, body: object, options?: AxiosRequestConfig): AxiosPromise<CommunicationReturnData>;

}

/**
 * CommunicationApi - object-oriented interface
 * @export
 * @class CommunicationApi
 * @extends {BaseAPI}
 */
export class CommunicationApi extends BaseAPI implements CommunicationApiInterface {
    /**
     * get specific process communication
     * @summary get specific process communication
     * @param {string} id communication identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunicationApi
     */
    public getCommunication(id: string, options?: AxiosRequestConfig) {
        return CommunicationApiFp(this.configuration).getCommunication(id, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get specific process communication by workflow and product
     * @summary get specific process communication by workflow and product
     * @param {string} workflow communication workflow type
     * @param {string} product product identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunicationApi
     */
    public getCommunicationByWorkflowAndProduct(workflow: string, product: string, options?: AxiosRequestConfig) {
        return CommunicationApiFp(this.configuration).getCommunicationByWorkflowAndProduct(workflow, product, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * process communication
     * @summary process communication
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunicationApi
     */
    public getProcessCommunication(options?: AxiosRequestConfig) {
        return CommunicationApiFp(this.configuration).getProcessCommunication(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get specific process communication by workflow and product
     * @summary get specific process communication by workflow and product
     * @param {string} workflow communication workflow type
     * @param {string} product product identifier
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunicationApi
     */
    public getPubCommunicationByWorkflowAndProduct(workflow: string, product: string, options?: AxiosRequestConfig) {
        return CommunicationApiFp(this.configuration).getPubCommunicationByWorkflowAndProduct(workflow, product, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * process communication
     * @summary process communication
     * @param {number} storeId store identifier
     * @param {CommunicationEntryData} communicationEntryData update process communication object
     * @param {string} [lang] language code for communication
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunicationApi
     */
    public processCommunication(storeId: number, communicationEntryData: CommunicationEntryData, lang?: string, options?: AxiosRequestConfig) {
        return CommunicationApiFp(this.configuration).processCommunication(storeId, communicationEntryData, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * process communication with user id
     * @summary process communication with user id
     * @param {number} storeId store identifier
     * @param {CommunicationEntryData} communicationEntryData update process communication object
     * @param {number} [userId] user identifier for external communication
     * @param {string} [lang] language code for communication
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunicationApi
     */
    public processCommunicationExternal(storeId: number, communicationEntryData: CommunicationEntryData, userId?: number, lang?: string, options?: AxiosRequestConfig) {
        return CommunicationApiFp(this.configuration).processCommunicationExternal(storeId, communicationEntryData, userId, lang, options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * update process communication
     * @summary update process communication
     * @param {string} id communication identifier
     * @param {string} actionId action identifier for communication update
     * @param {object} body process communication object
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof CommunicationApi
     */
    public updateCommunication(id: string, actionId: string, body: object, options?: AxiosRequestConfig) {
        return CommunicationApiFp(this.configuration).updateCommunication(id, actionId, body, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TemplateApi - axios parameter creator
 * @export
 */
export const TemplateApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * get Communication Translate
         * @summary get Communication Translate
         * @param {string} id communication identifier
         * @param {string} locale locale for template translation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommunicationTranslate: async (id: string, locale: string, options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            // verify required parameter 'id' is not null or undefined
            assertParamExists('getCommunicationTranslate', 'id', id)
            // verify required parameter 'locale' is not null or undefined
            assertParamExists('getCommunicationTranslate', 'locale', locale)
            const localVarPath = `/api/preowned-resell/1/communication/{id}/template`
                .replace(`{${"id"}}`, encodeURIComponent(String(id)));
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;

            // authentication itxBearerAuth required
            // http bearer authentication required
            await setBearerAuthToObject(localVarHeaderParameter, configuration)

            if (locale !== undefined) {
                localVarQueryParameter['locale'] = locale;
            }


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TemplateApi - functional programming interface
 * @export
 */
export const TemplateApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TemplateApiAxiosParamCreator(configuration)
    return {
        /**
         * get Communication Translate
         * @summary get Communication Translate
         * @param {string} id communication identifier
         * @param {string} locale locale for template translation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getCommunicationTranslate(id: string, locale: string, options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<TemplateTranslate>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getCommunicationTranslate(id, locale, options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TemplateApi - factory interface
 * @export
 */
export const TemplateApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TemplateApiFp(configuration)
    return {
        /**
         * get Communication Translate
         * @summary get Communication Translate
         * @param {string} id communication identifier
         * @param {string} locale locale for template translation
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getCommunicationTranslate(id: string, locale: string, options?: any): AxiosPromise<TemplateTranslate> {
            return localVarFp.getCommunicationTranslate(id, locale, options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TemplateApi - interface
 * @export
 * @interface TemplateApi
 */
export interface TemplateApiInterface {
    /**
     * get Communication Translate
     * @summary get Communication Translate
     * @param {string} id communication identifier
     * @param {string} locale locale for template translation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateApiInterface
     */
    getCommunicationTranslate(id: string, locale: string, options?: AxiosRequestConfig): AxiosPromise<TemplateTranslate>;

}

/**
 * TemplateApi - object-oriented interface
 * @export
 * @class TemplateApi
 * @extends {BaseAPI}
 */
export class TemplateApi extends BaseAPI implements TemplateApiInterface {
    /**
     * get Communication Translate
     * @summary get Communication Translate
     * @param {string} id communication identifier
     * @param {string} locale locale for template translation
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TemplateApi
     */
    public getCommunicationTranslate(id: string, locale: string, options?: AxiosRequestConfig) {
        return TemplateApiFp(this.configuration).getCommunicationTranslate(id, locale, options).then((request) => request(this.axios, this.basePath));
    }
}


/**
 * TokenApi - axios parameter creator
 * @export
 */
export const TokenApiAxiosParamCreator = function (configuration?: Configuration) {
    return {
        /**
         * get token
         * @summary get token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getToken: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/public/4/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
        /**
         * get Validate
         * @summary get Validate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidate: async (options: AxiosRequestConfig = {}): Promise<RequestArgs> => {
            const localVarPath = `/itxrest/4/private/validate/token`;
            // use dummy base URL string because the URL constructor only accepts absolute URLs.
            const localVarUrlObj = new URL(localVarPath, DUMMY_BASE_URL);
            let baseOptions;
            if (configuration) {
                baseOptions = configuration.baseOptions;
            }

            const localVarRequestOptions = { method: 'GET', ...baseOptions, ...options};
            const localVarHeaderParameter = {} as any;
            const localVarQueryParameter = {} as any;


    
            setSearchParams(localVarUrlObj, localVarQueryParameter);
            let headersFromBaseOptions = baseOptions && baseOptions.headers ? baseOptions.headers : {};
            localVarRequestOptions.headers = {...localVarHeaderParameter, ...headersFromBaseOptions, ...options.headers};

            return {
                url: toPathString(localVarUrlObj),
                options: localVarRequestOptions,
            };
        },
    }
};

/**
 * TokenApi - functional programming interface
 * @export
 */
export const TokenApiFp = function(configuration?: Configuration) {
    const localVarAxiosParamCreator = TokenApiAxiosParamCreator(configuration)
    return {
        /**
         * get token
         * @summary get token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getToken(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Token>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getToken(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
        /**
         * get Validate
         * @summary get Validate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        async getValidate(options?: AxiosRequestConfig): Promise<(axios?: AxiosInstance, basePath?: string) => AxiosPromise<Data>> {
            const localVarAxiosArgs = await localVarAxiosParamCreator.getValidate(options);
            return createRequestFunction(localVarAxiosArgs, globalAxios, BASE_PATH, configuration);
        },
    }
};

/**
 * TokenApi - factory interface
 * @export
 */
export const TokenApiFactory = function (configuration?: Configuration, basePath?: string, axios?: AxiosInstance) {
    const localVarFp = TokenApiFp(configuration)
    return {
        /**
         * get token
         * @summary get token
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getToken(options?: any): AxiosPromise<Token> {
            return localVarFp.getToken(options).then((request) => request(axios, basePath));
        },
        /**
         * get Validate
         * @summary get Validate
         * @param {*} [options] Override http request option.
         * @throws {RequiredError}
         */
        getValidate(options?: any): AxiosPromise<Data> {
            return localVarFp.getValidate(options).then((request) => request(axios, basePath));
        },
    };
};

/**
 * TokenApi - interface
 * @export
 * @interface TokenApi
 */
export interface TokenApiInterface {
    /**
     * get token
     * @summary get token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokenApiInterface
     */
    getToken(options?: AxiosRequestConfig): AxiosPromise<Token>;

    /**
     * get Validate
     * @summary get Validate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokenApiInterface
     */
    getValidate(options?: AxiosRequestConfig): AxiosPromise<Data>;

}

/**
 * TokenApi - object-oriented interface
 * @export
 * @class TokenApi
 * @extends {BaseAPI}
 */
export class TokenApi extends BaseAPI implements TokenApiInterface {
    /**
     * get token
     * @summary get token
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokenApi
     */
    public getToken(options?: AxiosRequestConfig) {
        return TokenApiFp(this.configuration).getToken(options).then((request) => request(this.axios, this.basePath));
    }

    /**
     * get Validate
     * @summary get Validate
     * @param {*} [options] Override http request option.
     * @throws {RequiredError}
     * @memberof TokenApi
     */
    public getValidate(options?: AxiosRequestConfig) {
        return TokenApiFp(this.configuration).getValidate(options).then((request) => request(this.axios, this.basePath));
    }
}


